import { useMemo } from 'react';
import { useLocalStorage } from 'src/domain/useLocalStorage';
import { AGREEMENT_STATUSES_PAGE_CONST } from './constants';

export const useAgreementStatusesSidebar = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(AGREEMENT_STATUSES_PAGE_CONST.localStorage.sidebarCollapsedKey, false);

    const layoutPaddingLeft = useMemo(() => {
        return sidebarCollapsed ? '35px' : '200px';
    }, [sidebarCollapsed]);

    return {
        sidebarCollapsed,
        setSidebarCollapsed,
        layoutPaddingLeft,
    };
};
